import { ChipOrderStatus } from 'modules/account/orderModule/common/components';

import { OrdersListItem } from '../../../types';

export const renderStatus = (item: OrdersListItem) => (
  <ChipOrderStatus status={item.status} uppercase={false} variant="small" />
);
